import { INTERNAL_EVENT_ERROR_KEY } from '../../constants';
import { InternalEvent } from '../../enums';
import { InternalMessageEvent } from '../../types';
import { isInternalEventOrigin } from '../../utils/origin';
import { isInternalEventSource } from '../../utils/source';
import { isInternalEventPayload } from '../payload';

export const isInternalEvent = (value: unknown): value is InternalEvent =>
  Object.values(InternalEvent).includes(value as InternalEvent);

export const isMessageInternalEvent = (
  messageEvent: MessageEvent
): messageEvent is InternalMessageEvent => {
  const { action, payload, source } = messageEvent.data;
  if (!isInternalEventOrigin(messageEvent.origin)) return false;
  if (!isInternalEventSource(source)) return false;

  if (!isInternalEvent(action)) {
    throw new Error(
      `${INTERNAL_EVENT_ERROR_KEY} Received invalid event ${action}`
    );
  }

  if (!isInternalEventPayload(action, payload)) {
    throw new Error(
      `${INTERNAL_EVENT_ERROR_KEY} Received invalid payload for event ${action}`
    );
  }

  return true;
};
